import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Grid } from '@mui/material';
import { CSSProperties } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { useHover } from 'react-use';
import styled from 'styled-components';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import Text from '../../../../../../react-components/Text';

export interface SortableOptionPillItem {
  id: string;
  text: string;
  is_custom_field: boolean;
}

interface ContainerProps {
  isDragging?: boolean;
  isGroupedOver?: boolean;
}

const Container = styled(Grid)<ContainerProps>`
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  padding: 8px;
  margin: 8px 0;
  height: 42px;
  background-color: ${(props) => (props.isDragging ? RoutalPalette.neutral10 : RoutalPalette.neutral00)};
`;

const getStyle = (provided: DraggableProvided, style?: CSSProperties) => {
  if (!style) {
    return provided.draggableProps.style;
  }

  return {
    ...provided.draggableProps.style,
    ...style,
  };
};

interface SortableOptionPillProps {
  field: SortableOptionPillItem;
  isDragging: boolean;
  provided: DraggableProvided;
  isGroupedOver?: boolean;
  style?: CSSProperties;
  index?: number;
}

export const SortableOptionPill = ({
  field,
  isDragging,
  isGroupedOver,
  provided,
  style,
  index,
}: SortableOptionPillProps) => {
  const [hoverable] = useHover((hovered: boolean) => (
    <Container
      isDragging={isDragging}
      isGroupedOver={isGroupedOver}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={getStyle(provided, style)}
      data-is-dragging={isDragging}
      data-testid={field.id}
      data-index={index}
      aria-label={`${field.id} field`}
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Text style={{ cursor: hovered ? `grab` : `default` }} variant="body">
        {field.text}
      </Text>
      <Grid
        item
        container
        direction="row"
        alignItems="center"
        style={{
          visibility: hovered ? `visible` : `hidden`,
          width: `unset`,
          height: `100%`,
          position: `absolute`,
          right: 0,
          background: `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%)`,
        }}
      >
        <DragIndicatorIcon style={{ color: RoutalPalette.grey1 }} />
      </Grid>
    </Container>
  ));

  return hoverable;
};
